import BaseService from "../../base/base_service";
import {SYSTEM_EVENTS} from "../../events/events";
import Event from "../../utils/event";
import * as MDP_CONSTS from "../../components/message/message_consts";
import {CashierSessionTypes} from "../../../../common/const/cashier-session-types";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

interface IBetRejectedData {
    RejectionReasonId: number;
    GameTypeID: number;
    RealMoneyBalance: number;
    BetCurrencyCode: string;
}

const BET_REJECT_REASON_ID_MAP = {
    'Sport': 1,
    'Poker': 2,
    'PokerAndSport': 3,
};

export default class BonusAbuseParkingMoneyInSportAndPokerService extends BaseService {
    static CLASS = "BonusAbuseParkingMoneyInSportAndPokerService";

    init() {
        this._subscribe();
    }

    private _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.BONUS_ABUSE_PARKING_MONEY, this._showBonusAbuseParkingMoneyMessage)
    }

    private _showBonusAbuseParkingMoneyMessage(data: IBetRejectedData) {
        let contentText;
        switch(data.RejectionReasonId){
            case BET_REJECT_REASON_ID_MAP.Poker:
                contentText = `bonus_abuse_parking_money_text_poker_${data.RealMoneyBalance > 0 ? 'with' : 'without'}_real_money`;
                break;
            case BET_REJECT_REASON_ID_MAP.Sport:
                contentText = `bonus_abuse_parking_money_text_sport_${data.RealMoneyBalance > 0 ? 'with' : 'without'}_real_money`;
                break;
            case BET_REJECT_REASON_ID_MAP.PokerAndSport:
                contentText = `bonus_abuse_parking_money_text_poker_and_sport_${data.RealMoneyBalance > 0 ? 'with' : 'without'}_real_money`;
                break;
        }

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Bonus_Availability_Popup',
            action: 'Show' ,
            label: data.GameTypeID,
            value: data.RejectionReasonId
        });


        const isGameRunning = this.serviceFactory.gameService().isGameRunning();

        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            title: this.serviceFactory.languageService().translation('bonus_abuse_parking_money_title'),
            text: this.serviceFactory.languageService().translation(contentText, {
                RealMoneyBalance: this.serviceFactory.currencyService().formatMoney(data.RealMoneyBalance)
            }),
            closeButton: false,
            hasDefaultButton: false,
            contentAlign: MDP_CONSTS.TEXT_ALIGNMENT.LEFT,
            customCSSClassList: ['cgp-mdp-text-support-slash-n'],
            buttons: [
            {
                name: this.serviceFactory.languageService().translation('logged_in_cashier_btn'),
                callback: () => {
                    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                        category: 'Bonus_Availability_Popup',
                        action: 'CTA_Click' ,
                        label: 'cashier_btn'
                    });

                    this.serviceFactory.cashierProxyService().openCashier({
                        sessionType: CashierSessionTypes.FULL_CASHIER,
                        channel: {
                            source: CHANNEL_SOURCE.casinoClient,
                            area: AreaType.Message,
                            element: CHANNEL_ELEMENTS.depositButton
                        }

                    });
                }
            },
            {
                name: this.serviceFactory.languageService().translation(isGameRunning ? 'close_game' : 'close_btn'),
                type: "secondary",
                callback: () => {
                    let label = 'Close Message';
                    if(isGameRunning) {
                        label = 'Close Game';
                        this.serviceFactory.gameService().closeRunningGame();
                    }

                    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
                        category: 'Bonus_Availability_Popup',
                        action: 'CTA_Click' ,
                        label: label
                    });
                }
            }
        ],
            showPopupAboveSecondWebViewHybrid: true
        });
    }
}
